import { render } from "./UploadLinkForm.vue?vue&type=template&id=03c997bc"
import script from "./UploadLinkForm.vue?vue&type=script&lang=ts"
export * from "./UploadLinkForm.vue?vue&type=script&lang=ts"
script.render = render

export default script